import { render } from "./ItSupportPage.vue?vue&type=template&id=b0d0dd60&scoped=true"
import script from "./ItSupportPage.vue?vue&type=script&lang=js"
export * from "./ItSupportPage.vue?vue&type=script&lang=js"

import "./ItSupportPage.vue?vue&type=style&index=0&id=b0d0dd60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0d0dd60"]])

export default __exports__